var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"iframeRef",staticClass:"bb-iframe",staticStyle:{"width":"100%","border":"0","display":"block"},attrs:{"title":`bb-widget-${_vm.bbId || _vm.bbSpaceId || 'preview'}`,"sandbox":"allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"}})
}
var staticRenderFns = []

export { render, staticRenderFns }